import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { ITlfActionRemoveVariantTemplate, TlfContextProps, UPDATE_TLF } from "./interface";
import { tlf_updateTlf } from "./tlf_updateTlf";

/**
 * Removes a named template while retaining the catalogue and current table composition.
 *
 * @param state - Current TLF definitions, patch selection and persisted save point
 * @param action - Template name to remove from the unsaved TLF
 * @returns Updated definitions, or unchanged state when template editing is unavailable
 */
export const tlf_removeVariantTemplate = (
  state: TlfContextProps,
  action: ITlfActionRemoveVariantTemplate,
): TlfContextProps => {
  if (state.readOnly || !isArsMasterReadDto(state.tlfData)) return state;
  return tlf_updateTlf(state, {
    operation: UPDATE_TLF,
    tlfData: {
      ...state.tlfData,
      variantTemplates: state.tlfData.variantTemplates.filter(
        (template) => template.name !== action.variantName,
      ),
    },
    calledFrom: action.calledFrom,
  });
};
